import UserProfile from "@/domain/entities/user/UserProfile";
import { AuthUser } from "@cs_teamwaydev/mailvista-sdk_react";

export type AccountIdentity = {
    displayName: string;
    email: string;
    initials: string;
    photoURL?: string;
};

const initialsFrom = (displayName: string): string =>
    displayName
        .split(" ")
        .filter(Boolean)
        .map((part) => part[0])
        .join("")
        .slice(0, 2);

export const accountIdentityFromUserProfile = (
    user: UserProfile,
): AccountIdentity => ({
    displayName: user.profile.displayName,
    email: user.profile.email,
    initials: user.getInitials,
    photoURL: user.photoURL,
});

export const accountIdentityFromAuthUser = (
    user: AuthUser,
): AccountIdentity => {
    const displayName = user.name || user.username || user.email;

    return {
        displayName,
        email: user.email,
        initials: initialsFrom(displayName),
    };
};

export const accountIdentityFromEmail = (email: string): AccountIdentity => ({
    displayName: email,
    email,
    initials: initialsFrom(email),
});
